import { makeStyles } from '@material-ui/core/styles'
import { topbarHeight } from 'src/Constants'

export const topBarStyle = makeStyles(theme => ({
  root: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'left',
    background: theme.palette.geoColors.topBar.main
  },
  logo: {
    width: '33%',
    height: topbarHeight
  },
  image: {
    marginLeft: theme.spacing(2),
    height: topbarHeight
  },
  buttons: {
    width: '33%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    paddingRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  userInfo: {
  },
  searchField: {
    width: '33%',
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  themeImage: {
    marginLeft: 20,
    color: theme.palette.common.white,
    fontSize: '1.5rem',
    height: topbarHeight
  },
  wikiButton: {
  },
  wikiIcon: {
    color: theme.palette.common.white,
    height: topbarHeight
  }
}))
